import { render, staticRenderFns } from "./Dodavatel.vue?vue&type=template&id=b84413b2&"
import script from "./Dodavatel.vue?vue&type=script&lang=js&"
export * from "./Dodavatel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAutocomplete,VIcon,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("C:\\azagent\\_work\\3\\s\\master-v3\\Filip.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b84413b2')) {
      api.createRecord('b84413b2', component.options)
    } else {
      api.reload('b84413b2', component.options)
    }
    module.hot.accept("./Dodavatel.vue?vue&type=template&id=b84413b2&", function () {
      api.rerender('b84413b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/basic/Dodavatel.vue"
export default component.exports